var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15 0c.552 0 1 .445 1 .996v9.008c0 .55-.445.996-1 .996H10.33l.353 1.063c.152.461.28 1.187.31 1.721L11 14H4.993c0-.543.14-1.402.318-1.937L5.666 11H1.001C.448 11 0 10.555 0 10.004V.996C0 .446.445 0 1 0zm-1 2H2v7h12z"
})));
export default SvgDesktop;